// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type {
  TManagerUserStatsPayload,
  TManagerUserStatsResponse,
} from '~/modules/manager/company/stats/types';

// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';

export class ManagerCompanyStatsModel extends ManagerResource {
  stats(
    companyId: number,
    payload: TManagerUserStatsPayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TManagerUserStatsResponse[]> {
    return this.get<TManagerUserStatsResponse[]>(
      `companies/${companyId}/stats`,
      payload,
      requestConfig
    );
  }
}
